<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>扬尘管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <!-- <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>-->
                <el-button type="primary" @click="addRow()">绑定设备</el-button>
                <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
                <!-- <router-link class="btnLef" :to="{name:'dustManData'}">数据统计</router-link> -->
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" border>
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80" type="index"></el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <a>{{ scope.row.id}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="位置描述" width="90">
                    <template slot-scope="scope">
                    <span>{{ scope.row.description }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="噪音">
                    <template slot-scope="scope">
                    <span>{{ scope.row.noise }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="PM2.5">
                    <template slot-scope="scope">
                    <span>{{ scope.row.pm2 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="PM10">
                    <template slot-scope="scope">
                    <span>{{ scope.row.pm10 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="风速">
                    <template slot-scope="scope">
                    <span>{{ scope.row.windSpeed }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="风向">
                    <template slot-scope="scope">
                    <span>{{ scope.row.windDirection }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="温度">
                    <template slot-scope="scope">
                    <span>{{ scope.row.temperature }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="湿度">
                    <template slot-scope="scope">
                    <span>{{ scope.row.humidity }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="上传大气办" width="100">
                    <template slot-scope="scope">
                    <span style="color:red">{{ (scope.row.timely) == 1 ? "是": "否" }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="时间" width="160">
                    <template slot-scope="scope">
                    <span>{{ scope.row.updateDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="170">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle1"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="位置描述：">
                        <el-input v-model="addForm.description" placeholder="请输入位置描述" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="序列号：" prop="id">
                        <el-input v-model="addForm.id" placeholder="请输入序列号" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="上传大气办：">
                        <el-radio-group v-model="addForm.airFlag">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0" style="margin-left:20px;">否</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>

                <!-- 维护标准窗口 -->
                <el-dialog
                    title="参数配置"
                    :visible.sync="editFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    custom-class='tower-dig'
                    class="add-form"
                    width="60%"
                >
                  <div class="config-con">
                    <p class="config-con-item" v-for="(item,index) in configList" :key="index">
                      <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
                      <span style="display: inline-block;width: 7vw;">单位：（{{item.unit}}）</span>
                      <span style="display: inline-block;width: 14vw;">设备报警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
                      <span>默认使用系统设置</span>
                      <el-switch
                        v-model="item.status"
                        inactive-text="关闭">
                      </el-switch>
                    </p>
                  </div>
                  <div slot="footer" class="dialog-footer" style="">
                      <el-button @click="editFormVisible = false">取 消</el-button>
                      <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
                  </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      // projectId: '',
      dialogTitle1: '', // 添加设备标题
      dialogTitle: '', //标准
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
        description: '',
        id: '',
        airFlag: '0'
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 扬尘表单数据
      // currentPage: 1, // 表单列表默认页
      // pageSize: 10, // 表单列表默认显示数
      // totalItems: 0, // 表单列表全部长度
      flag: false, // 搜索数据flag值
      projectId: util.session.get('groupId'),
      standard: {
        //标准
      },
      dataText: '数据加载中...',
      rules: {
        id: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
      },
      //配置弹出框
      editFormVisible: false, // 弹出框是否显示
      configList:[
        {name:'PM2.5',unit:'PM2.5',val:'',status:true},
        {name:'PM10',unit:'PM10',val:'',status:true},
        {name:'噪音',unit:'分贝',val:'',status:true},
        {name:'温度',unit:'摄氏度',val:'',status:true},
        {name:'湿度',unit:'百分比',val:'',status:true},
        {name:'风速',unit:'米每秒',val:'',status:true},
      ],
      configData:{
        id:'',
        projectId:'',
        projectName:'',
        noiseSwitch:'',  //噪音开关   1开  2关
        noise:'',        //噪音
        pm2Switch:'',    //PM2.5开关   1开  2关
        pm2:'',          //PM2.5
        pm10Switch:'',   //PM10开关
        pm10:'',         //pm10
        temperatureSwitch:'',  //温度开关
        temperature:'',  //温度
        humiditySwitch:'',  // 湿度开关
        humidity:'',     //湿度
        windSpeedSwitch:'', //风速开关
        windSpeed:'',    //风速
        createBy:'',
      },
      hasConf:false,//判断是否已经有配置
      projectName:'',
    }
  },
  mounted() {
    this.getData()
    this.getProjectInfo()
  },
  methods: {
    // 搜索数据 111
    doFilter() {
      // var that = this
      // var option = {
      //   name: this.tableDataName,
      //   pageNum: this.currentPage,
      //   pageSize: this.pageSize,
      //   projectId: util.session.get('groupId')
      // }
      // myHttp.getListByProjectId(option).then(function(resp) {
      //   if (resp.data.code == '200') {
      //     var list = resp.data.data.dustList || [],
      //       arr = []
      //     for (var i = 0; i < list.length; i++) {
      //       if (list[i].id.split(that.tableDataName).length > 1) {
      //         arr.push(list[i])
      //         list[i].index = arr.length
      //       }
      //     }
      //     that.tableDataEnd = arr
      //     if (that.tableDataEnd != '') {
      //       that.$message.success('搜索如下')
      //     } else {
      //       that.$message.error('数据不存在')
      //     }
      //     console.log(that.tableDataEnd.index)
      //   } else {
      //     that.$message.error(resp.data.msg)
      //   }
      // })
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    //获取信息
    getProjectInfo(){
      var that = this
      myHttp.getProjectById({
        id:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          that.projectName = resp.data.data.project.name
        }
      })
    },

    // 获取数据
    getData() {
      var option = {
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getListByProjectId(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            // console.log(resp.data.data)
            var list = resp.data.data.dustList || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = list.length
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.dustDeleteInfo({
            id: row.id
        }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
        })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      // debugger
      this.dialogTitle1 = '新增设备'
      ;(this.addFormVisible = true),
        (this.addForm = {
          airFlag: '0',
          description: '',
          id: '',
          projectName: '',
          projectId: util.session.get('groupId')
        })
    },


    //插入数据
    setConfigList(data){
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configList[i].val = data.pm2
          this.configList[i].status = this.configData.pm2Switch=='2'?false:true
          // this.configData.pm2 = this.configList[i].val
          // this.configData.pm2Switch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configList[i].val = data.pm10
          this.configList[i].status = this.configData.pm10Switch=='2'?false:true
          // this.configData.pm10 = this.configList[i].val
          // this.configData.pm10Switch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configList[i].val = data.noise
          this.configList[i].status = this.configData.noiseSwitch=='2'?false:true
          // this.configData.noise = this.configList[i].val
          // this.configData.noiseSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configList[i].val = data.temperature
          this.configList[i].status = this.configData.temperatureSwitch=='2'?false:true
          // this.configData.temperature = this.configList[i].val
          // this.configData.temperatureSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configList[i].val = data.humidity
          this.configList[i].status = this.configData.humiditySwitch=='2'?false:true
          // this.configData.humidity = this.configList[i].val
          // this.configData.humiditySwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configList[i].val = data.windSpeed
          this.configList[i].status = this.configData.windSpeedSwitch=='2'?false:true
          // this.configData.windSpeed = this.configList[i].val
          // this.configData.windSpeedSwitch = this.configList[i].status?'1':'2'
        }
      }
    },

    // 维护标准
    handleEdit(index, row) {
      this.dialogTitle = '参数配置'
      this.editFormVisible = true
      this.configData.projectId = util.session.get('groupId')
      this.configData.projectName = this.projectName
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    // 维护环境标准configData
    sumbitEditRow(formName) {
      var that = this
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configData.pm2 = this.configList[i].val
          this.configData.pm2Switch = this.configList[i].status?'1':'2'
        }else if(i==1){
          this.configData.pm10 = this.configList[i].val
          this.configData.pm10Switch = this.configList[i].status?'1':'2'
        }else if(i==2){
          this.configData.noise = this.configList[i].val
          this.configData.noiseSwitch = this.configList[i].status?'1':'2'
        }else if(i==3){
          this.configData.temperature = this.configList[i].val
          this.configData.temperatureSwitch = this.configList[i].status?'1':'2'
        }else if(i==4){
          this.configData.humidity = this.configList[i].val
          this.configData.humiditySwitch = this.configList[i].status?'1':'2'
        }else if(i==5){
          this.configData.windSpeed = this.configList[i].val
          this.configData.windSpeedSwitch = this.configList[i].status?'1':'2'
        }
      }
      delete this.configData.createDate
      delete this.configData.updateDate
      
      if(this.hasConf){
        this.configData.updateBy = util.session.get('user').id
        myHttp.updateDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        this.configData.createBy = util.session.get('user').id
        myHttp.addDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }
      
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     if (that.addForm.id == '') {
      //       //修改 1111
      //       delete that.addForm.createDate
      //       delete that.addForm.updateDate
      //       // delete that.addForm.sqlMap
      //       if (that.addForm.password == '') {
      //         delete that.addForm.password
      //       }
      //       myHttp.machineCreateInfo(that.addForm).then(
      //         function(resp) {
      //           if (resp.data.code == '200') {
      //             that.$message.success('修改成功')
      //             that.addFormVisible = false
      //             that.getData()
      //           } else {
      //             that.$message.error(resp.data.msg)
      //           }
      //         },
      //         function() {}
      //       )
      //     }
      //   }
      // })
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.addForm.sn = that.addForm.id
          that.addForm.projectId = that.projectId
          that.addForm.projectName = that.getProName(that.projectId)
          myHttp.saveDustMon(that.addForm).then(
            function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addFormVisible = false
                // that.currentPage = 1
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
        }
      })
    },
    //获取项目名称
    getProName(id) {
      var list = this.$store.state.project
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (list[i].groupId == id) {
          result = list[i].groupName
        }
      }
      return result
    },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
        /* margin: 0 auto; */
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>
<style>
    .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
@import '../../../assets/css/common.css';
</style>